module.exports = __webpack_public_path__ + "static/img/53.2d715aad.png";